import { createAction } from 'redux-actions';
import { reduxKey } from '../../constants';
import { createNetworkRequestActionSet } from '../../../networking/utils';

export const setBrowsingModeWidgetContentFilter = createAction(
  `${reduxKey}.SET_BROWSINGMODE_WIDGET_CONTENT_FILTER`,
  (contentFilter: string) => ({ contentFilter })
);

export const {
  submit: saveBrowsingMode,
  success: saveBrowsingModeSuccess,
  failure: saveBrowsingModeFailure,
} = createNetworkRequestActionSet(reduxKey, 'SAVE_BROWSING_MODE');
